export const eventTaxonomyMappedField = {
  EVENT_TYPE: 'EventType',
  AUDIENCE: 'Audience',
  IN_LANGUAGE: 'inLanguage',
};
